export const LANDING_AMPLITUDE_EVENTS = {
	REMOVE_BG: 'remove bg',
	REMOVE_BG_V3: 'remove bg v3',
	MAIN: 'main',
	IMAGE_GEN: 'image gen',
	MAGIC_ERASER: 'magic eraser',
	IMAGE_ENHANCEMENT: 'image enhancer',
	IMAGE_ENHANCER: 'image enhancer',
	AI_IMAGE_EDITOR: 'ai image editor',
	OBJECT_REMOVER: 'object remover',
	BACKGROUND_REMOVER: 'background remover',
	HEADSHOT_GENERATOR: 'headshot generator',
	HEADSHOT_GENERATOR_V2: 'headshot generator v2',
	WATERMARK_REMOVER: 'watermark remover',
	VIDEO_WATERMARK_REMOVER: 'video watermark remover',
	IMAGE_WATERMARK_REMOVER: 'image watermark remover',
	TEXT_TO_VIDEO: 'text to video',
	IMAGE_TO_VIDEO: 'image to video',
	AI_VIDEO_GENERATOR: 'ai video generator',
	AI_IMAGE_COMBINER: 'ai image combiner',
	IMAGE_RESIZER: 'image resizer',
	IMAGE_RESIZER_LANDING: 'image resizer landing',
	CROP_IMAGE: 'crop image',
	CROP_IMAGE_LANDING: 'crop image landing',
	COLOR_PALETTE_FROM_IMAGE: 'color palette from image',
	COLOR_PALETTE_FROM_IMAGE_LANDING: 'color palette from image landing',
	HEX_COLOR_PICKER_FROM_IMAGE: 'hex color picker from image',
	HEX_COLOR_PICKER_FROM_IMAGE_LANDING: 'hex color picker from image landing',
	COLOR_PICKER_FROM_IMAGE: 'color picker from image',
	COLOR_PICKER_FROM_IMAGE_LANDING: 'color picker from image landing',
	RGB_COLOR_PICKER_FROM_IMAGE: 'rgb color picker from image',
	RGB_COLOR_PICKER_FROM_IMAGE_LANDING: 'rgb color picker from image landing',
	FLIP_IMAGE: 'flip image',
	FLIP_IMAGE_LANDING: 'flip image landing',
	ROTATE_IMAGE: 'rotate image',
	ROTATE_IMAGE_LANDING: 'rotate image landing',
	BACKGROUND_EDITOR: 'background editor',
	BACKGROUND_EDITOR_LANDING: 'background editor landing',
	BACKGROUND_CHANGER: 'background changer',
	BACKGROUND_CHANGER_LANDING: 'background changer landing',
	BLUR_BACKGROUND: 'blur background',
	BLUR_BACKGROUND_LANDING: 'blur background landing',
	PASSPORT_PHOTO_MAKER: 'passport photo maker',
	SOUTH_PARK_CHARACTER_GENERATOR: 'south park character generator',
	AI_ART_GENERATOR: 'ai art generator',
	AI_CLAY_FILTER: 'ai clay filter',
	AI_BRATZ_GENERATOR: 'ai bratz generator',
	AI_FILTERS: 'ai filters',
	PHOTO_RECOLOR: 'ai recolor v1',
	ANIME_GENERATOR: 'anime generator',
	CARTOON_GENERATOR: 'cartoon generator',
	PIXAR_AI_GENERATOR: 'pixar ai generator',
	AI_CHIBI_MAKER: 'ai chibi maker',
	CLOTHES_CHANGER: 'ai clothes changer v1',
	AI_IMAGE_EXTENDER: 'ai image extender',
	AI_IMAGE_EXTENDER_V2: 'ai image extender v2',
	AI_HAIRSTYLE: 'ai hairstyle changer',
	AI_HAIRSTYLE_V2: 'ai hairstyle changer v2',
	AI_IMAGE_QUALITY_IMPROVER: 'ai image quality improver',
	AI_IMAGE_DENOISER: 'ai image denoiser',
	AI_IMAGE_DEPIXELIZER: 'ai image depixelizer',
	AI_POKEMON_GENERATOR: 'ai pokemon generator',
	AI_RELIGHT: 'ai relight',
	AI_RETAKE: 'ai retake',
	HD_PHOTO_CONVERTER: 'hd photo converter',
	RESOLUTION_INCREASER: 'resolution-increaser',
	AI_IMAGE_ENLARGER: 'ai image enlarger',
	AI_PHOTO_RESTORATION: 'ai photo restoration',
	IMAGE_UNBLUR: 'image unblur',
	IMAGE_SHARPENER: 'image sharpener',
	AI_IMAGE_DETECTOR: 'ai image detector',
	AI_IMAGE_DETECTOR_LANDING: 'ai image detector landing',
	AI_IMAGE_GENERATOR: 'ai image generator',
	AI_IMAGE_GENERATOR_LANDING: 'ai image generator landing',
	TEXT_TO_IMAGE_AI: 'text to image ai',
	TEXT_TO_IMAGE_AI_LANDING: 'text to image ai landing',
	TEXT_TO_ART_AI: 'text to art ai',
	TEXT_TO_ART_AI_LANDING: 'text to art ai landing',
	IMAGE_COLORIZER: 'image colorizer',
	IMAGE_COLORIZER_V2: 'image colorizer v2',
	ALL_TOOLS: 'all tools',
	CHANGE_BG_COLOR: 'change bg color',
	AI_GENERATED_BACKGROUND: 'ai generated background',
	BLUR_BG: 'blur bg',
	ADD_TEXT_TO_PHOTO: 'add text to photo',
	LISTING: 'listing',
	MARKETPLACES: 'marketplaces',
	PRODUCT_CARDS: 'product cards',
	PROMOTE_EVENTS: 'promote events',
	CREATE_CONTENT: 'create social media content landing',
	GENERATE_IMAGES_WITH_AI: 'generate images with AI',
	REVIEWS: 'reviews',
	IMAGE_ENHANCER_LANDING: 'image enhancer landing',
	OBJECT_REMOVER_LANDING: 'object remover landing',
	BACKGROUND_REMOVER_LANDING: 'background remover landing',
	ALL_TOOLS_LANDING: 'all tools landing',
	CREATE_SMC: 'create social media content',
	BUSINESS_LANDING: 'for business landing',
	APPAREL_PHOTOGRAPHY: 'apparel photography',
	FOR_BUSINESS_LANDING: 'for business landing',
	FURNITURE_IMAGES_LANDING: 'furniture images landing',
	BEAUTY_PRODUCTS_LANDING: 'beauty product photography landing',
	JEWELRY_IMAGES_LANDING: 'jewelry images landing',
	ONLINE_CREATIVE_LANDING: 'online creatives landing',
	BRANDED_GRAPHIC_LANDING: 'branded graphics landing',
	EMAIL_MARKETING_LANDING: 'email marketing landing',
	REAL_ESTATE_LANDING: 'real estate landing',
	MAGIC_ERASER_V2: 'magic eraser v2',
	IMAGE_UPSCALE_LANDING: 'image upscale landing',
	IMAGE_UPSCALER_LANDING: 'image upscaler landing',
	MAGIC_ERASER_V3: 'magic eraser v3',
	IMAGE_ENHANCEMENT_V2: 'image enhancer v2',
	IMAGE_UPSCALE_LANDING_V2: 'image upscale landing v2',
	IMAGE_UPSCALE_LANDING_V3: 'image upscale landing v3',
	IMAGE_UPSCALE_V2: 'image upscale v2',
	IMAGE_UPSCALE_V3: 'image upscale v3',
	IMAGE_UPSCALER: 'image upscaler',
	AI_FILTERS_LEGO_LANDING: 'AI filters lego landing',
	AI_FILTERS_LEGO: 'AI filters lego',
	AI_FILTERS_GHIBLI_LANDING: 'AI filters ghibli landing',
	AI_FILTERS_GHIBLI: 'AI filters ghibli',
	AI_FILTERS_STARTER_PACK_LANDING: 'AI filters starter pack landing',
	AI_FILTERS_STARTER_PACK: 'AI filters starter pack',
	AI_DISNEY_FILTER: 'AI disney filter',
	HEADSHOT_GENERATOR_LANDING: 'headshot generator landing',
	HEADSHOT_GENERATOR_LANDING_V2: 'headshot generator landing v2',
	WATERMARK_REMOVER_LANDING: 'watermark remover landing',
	VIDEO_WATERMARK_REMOVER_LANDING: 'video watermark remover landing',
	IMAGE_WATERMARK_REMOVER_LANDING: 'image watermark remover landing',
	TEXT_TO_VIDEO_LANDING: 'text to video landing',
	IMAGE_TO_VIDEO_LANDING: 'image to video landing',
	AI_VIDEO_GENERATOR_LANDING: 'ai video generator landing',
	AI_IMAGE_COMBINER_LANDING: 'ai image combiner landing',
	CUTOUT_IMAGE: 'cutout image',
	CUTOUT_IMAGE_LANDING: 'cutout image landing',
	PASSPORT_PHOTO_MAKER_LANDING: 'passport photo maker landing',
	SOUTH_PARK_CHARACTER_GENERATOR_LANDING:
		'south park character generator landing',
	AI_ART_GENERATOR_LANDING: 'ai art generator landing',
	AI_CLAY_FILTER_LANDING: 'ai clay filter landing',
	AI_BRATZ_GENERATOR_LANDING: 'ai bratz generator landing',
	AI_POKEMON_GENERATOR_LANDING: 'ai pokemon generator landing',
	AI_DISNEY_FILTER_LANDING: 'ai disney filter landing',
	AI_FILTERS_LANDING: 'ai filters landing',
	PHOTO_RECOLOR_LANDING: 'photo recolor landing',
	CLOTHES_CHANGER_LANDING: 'ai clothes changer v1 landing',
	AI_NEON_FILTER: 'ai neon filter',
	AI_NEON_FILTER_LANDING: 'ai neon filter landing',
	ANIME_GENERATOR_LANDING: 'anime generator landing',
	CARTOON_GENERATOR_LANDING: 'cartoon generator landing',
	PIXAR_AI_GENERATOR_LANDING: 'pixar ai generator landing',
	AI_CHIBI_MAKER_LANDING: 'ai chibi maker landing',
	AI_IMAGE_EXTENDER_LANDING: 'ai image extender landing',
	AI_IMAGE_EXTENDER_LANDING_V2: 'ai image extender landing v2',
	AI_HAIRSTYLE_LANDING: 'ai hairstyle changer landing',
	AI_HAIRSTYLE_LANDING_V2: 'ai hairstyle changer landing v2',
	AI_IMAGE_QUALITY_IMPROVER_LANDING: 'ai image quality improver landing',
	AI_RELIGHT_LANDING: 'ai relight landing',
	AI_RETAKE_LANDING: 'ai retake landing',
	HD_PHOTO_CONVERTER_LANDING: 'hd photo converter landing',
	AI_IMAGE_DEPIXELIZER_LANDING: 'ai image depixelizer landing',
	AI_IMAGE_DENOISER_LANDING: 'ai image denoiser landing',
	RESOLUTION_INCREASER_LANDING: 'resolution-increaser landing',
	AI_IMAGE_ENLARGER_LANDING: 'ai image enlarger landing',
	AI_IMAGE_EDITOR_LANDING: 'ai image editor landing',
	AI_PHOTO_RESTORATION_LANDING: 'ai photo restoration landing',
	IMAGE_UNBLUR_LANDING: 'image unblur landing',
	IMAGE_SHARPENER_LANDING: 'image sharpener landing',
	IMAGE_COLORIZER_LANDING: 'image colorizer landing',
	IMAGE_COLORIZER_LANDING_V2: 'image colorizer landing v2',
	IMAGE_TO_TEXT: 'image to text',
	IMAGE_TO_TEXT_LANDING: 'image to text landing',
	AI_FACE_SWAP_LANDING: 'ai face swap v1',
	PHOTO_TO_ILLUSTRATION: 'photo to illustration',
	PHOTO_TO_ILLUSTRATION_LANDING: 'photo to illustration landing',
	IMAGE_TO_DRAWING: 'image to drawing',
	IMAGE_TO_DRAWING_LANDING: 'image to drawing landing',
	AI_COMIC_FILTER: 'ai comic filter',
	AI_COMIC_FILTER_LANDING: 'ai comic filter landing',
	PHOTO_TO_PAINTING: 'photo to painting',
	PHOTO_TO_PAINTING_LANDING: 'photo to painting landing',
	PHOTO_TO_SKETCH: 'photo to sketch',
	PHOTO_TO_SKETCH_LANDING: 'photo to sketch landing',
	AI_BARBIE_DOLL: 'ai barbie doll',
	AI_BARBIE_DOLL_LANDING: 'ai barbie doll landing',
	AI_DOLL_GENERATOR: 'ai doll generator',
	AI_DOLL_GENERATOR_LANDING: 'ai doll generator landing',
	AI_MANGA_GENERATOR: 'ai manga generator',
	AI_MANGA_GENERATOR_LANDING: 'ai manga generator landing',
	AI_ACTION_FIGURE_GENERATOR: 'ai action figure generator',
	AI_ACTION_FIGURE_GENERATOR_LANDING: 'ai action figure generator landing',
	AI_TOY_GENERATOR: 'ai toy generator',
	AI_TOY_GENERATOR_LANDING: 'ai toy generator landing',
	GENERATIVE_FILL: 'generative fill',
	GENERATIVE_FILL_LANDING: 'generative fill landing',
	AI_BACKGROUND: 'ai background',
	AI_BACKGROUND_LANDING: 'ai background landing',
	AI_PFP_MAKER: 'ai pfp maker',
	AI_PFP_MAKER_LANDING: 'ai pfp maker landing',
	AI_PROFILE_PICTURE_MAKER: 'ai profile picture maker',
	AI_PROFILE_PICTURE_MAKER_LANDING: 'ai profile picture maker landing',
	AI_AVATAR_GENERATOR: 'ai avatar generator',
	AI_AVATAR_GENERATOR_LANDING: 'ai avatar generator landing',
	AI_PORTRAIT_GENERATOR: 'ai portrait generator',
	AI_PORTRAIT_GENERATOR_LANDING: 'ai portrait generator landing',
	PROFESSIONAL_AI_HEADSHOTS: 'professional ai headshots',
	PROFESSIONAL_AI_HEADSHOTS_LANDING: 'professional ai headshots landing',
	AI_CV_PHOTO_GENERATOR: 'ai cv photo generator',
	AI_CV_PHOTO_GENERATOR_LANDING: 'ai cv photo generator landing',
	AI_BUSINESS_PHOTO_GENERATOR: 'ai business photo generator',
	AI_BUSINESS_PHOTO_GENERATOR_LANDING: 'ai business photo generator landing',
	AI_DATING_PHOTO_GENERATOR: 'ai dating photo generator',
	AI_DATING_PHOTO_GENERATOR_LANDING: 'ai dating photo generator landing',
	AI_TATTOO_GENERATOR: 'ai tattoo generator',
	AI_TATTOO_GENERATOR_LANDING: 'ai tattoo generator landing',
	TATTOO_FONT_GENERATOR: 'tattoo font generator',
	TATTOO_FONT_GENERATOR_LANDING: 'tattoo font generator landing',
	FONT_GENERATOR: 'font generator',
	FONT_GENERATOR_LANDING: 'font generator landing',
	TATTOO_TEXT_GENERATOR: 'tattoo text generator',
	TATTOO_TEXT_GENERATOR_LANDING: 'tattoo text generator landing',
	TATTOO_FROM_PHOTO_CONVERTER: 'tattoo from photo converter',
	TATTOO_FROM_PHOTO_CONVERTER_LANDING: 'tattoo from photo converter landing',
	PNG_MAKER: 'png maker',
	PNG_MAKER_LANDING: 'png maker landing',
	TRANSPARENT_BACKGROUND: 'transparent background',
	TRANSPARENT_BACKGROUND_LANDING: 'transparent background landing',
	SIGNATURE_BACKGROUND_REMOVER: 'signature background remover',
	SIGNATURE_BACKGROUND_REMOVER_LANDING: 'signature background remover landing',
	DELETE_BACKGROUND: 'delete background',
	DELETE_BACKGROUND_LANDING: 'delete background landing',
	CLEAR_BACKGROUND: 'clear background',
	CLEAR_BACKGROUND_LANDING: 'clear background landing',
	WHITE_BACKGROUND: 'white background',
	WHITE_BACKGROUND_LANDING: 'white background landing',
	BLACK_BACKGROUND: 'black background',
	BLACK_BACKGROUND_LANDING: 'black background landing',
	BACKGROUND_COLOR_CHANGER: 'background color changer',
	BACKGROUND_COLOR_CHANGER_LANDING: 'background color changer landing',
	AI_LOGO_GENERATOR: 'ai logo generator',
	AI_LOGO_GENERATOR_LANDING: 'ai logo generator landing',
	WEBP_TO_PNG: 'webp-to-png-converter',
	WEBP_TO_PNG_LANDING: 'webp to png converter landing',
	WEBP_TO_JPG: 'webp to jpg converter',
	WEBP_TO_JPG_LANDING: 'webp to jpg converter landing',
	WEBP_TO_JPEG: 'webp to jpeg converter',
	WEBP_TO_JPEG_LANDING: 'webp to jpeg converter landing',
	HEIC_TO_JPEG: 'heic to jpeg converter',
	HEIC_TO_JPEG_LANDING: 'heic to jpeg converter landing',
	HEIC_TO_JPG: 'heic to jpg converter',
	HEIC_TO_JPG_LANDING: 'heic to jpg converter landing',
	HEIC_TO_PNG: 'heic to png converter',
	HEIC_TO_PNG_LANDING: 'heic to png converter landing',
	PNG_CONVERTER: 'png converter',
	PNG_CONVERTER_LANDING: 'png converter landing',
	WEBP_CONVERTER: 'webp converter',
	WEBP_CONVERTER_LANDING: 'webp converter landing',
	TIFF_TO_JPG: 'tiff to jpg converter',
	TIFF_TO_JPG_LANDING: 'tiff to jpg converter landing',
	TIFF_TO_JPEG: 'tiff to jpeg converter',
	TIFF_TO_JPEG_LANDING: 'tiff to jpeg converter landing',
	TIFF_TO_PNG: 'tiff to png converter',
	TIFF_TO_PNG_LANDING: 'tiff to png converter landing',
	BMP_TO_JPEG: 'bmp to jpeg converter',
	BMP_TO_JPEG_LANDING: 'bmp to jpeg converter landing',
	BMP_TO_PNG_CONVERTER: 'bmp to png converter',
	BMP_TO_PNG_CONVERTER_LANDING: 'bmp to png converter landing',
	BMP_TO_JPG: 'bmp to jpg converter',
	BMP_TO_JPG_LANDING: 'bmp to jpg converter landing',
	JPG_TO_BMP_CONVERTER: 'jpg to bmp converter',
	JPG_TO_BMP_CONVERTER_LANDING: 'jpg to bmp converter landing',
	JPG_TO_TIFF_CONVERTER: 'jpg to tiff converter',
	JPG_TO_TIFF_CONVERTER_LANDING: 'jpg to tiff converter landing',
	JPEG_TO_TIFF_CONVERTER: 'jpeg to tiff converter',
	JPEG_TO_TIFF_CONVERTER_LANDING: 'jpeg to tiff converter landing',
	JPEG_TO_BMP_CONVERTER: 'jpeg to bmp converter',
	JPEG_TO_BMP_CONVERTER_LANDING: 'jpeg to bmp converter landing',
	IMAGE_TO_JPEG: 'image to jpeg converter',
	IMAGE_TO_JPEG_LANDING: 'image to jpeg converter landing',
	IMAGE_TO_HEIC: 'image to heic converter',
	IMAGE_TO_HEIC_LANDING: 'image to heic converter landing',
	IMAGE_TO_JPG: 'image to jpg converter',
	IMAGE_TO_JPG_LANDING: 'image to jpg converter landing',
	IMAGE_TO_BMP: 'image to bmp converter',
	IMAGE_TO_BMP_LANDING: 'image to bmp converter landing',
	IMAGE_TO_TIFF: 'image to tiff converter',
	IMAGE_TO_TIFF_LANDING: 'image to tiff converter landing',
	PNG_TO_JPEG: 'png to jpeg converter',
	PNG_TO_JPEG_LANDING: 'png to jpeg converter landing',
	PNG_TO_BMP: 'png to bmp converter',
	PNG_TO_BMP_LANDING: 'png to bmp converter landing',
	PNG_TO_JPG: 'png to jpg converter',
	PNG_TO_JPG_LANDING: 'png to jpg converter landing',
	JPEG_TO_JPG: 'jpeg to jpg converter',
	JPEG_TO_JPG_LANDING: 'jpeg to jpg converter landing',
	JPG_TO_JPEG: 'jpg to jpeg converter',
	JPG_TO_JPEG_LANDING: 'jpg to jpeg converter landing',
	PNG_TO_WEBP: 'png to webp converter',
	PNG_TO_WEBP_LANDING: 'png to webp converter landing',
	JPG_TO_WEBP: 'jpg to webp converter',
	JPG_TO_WEBP_LANDING: 'jpg to webp converter landing',
	JPEG_TO_WEBP: 'jpeg to webp converter',
	JPEG_TO_WEBP_LANDING: 'jpeg to webp converter landing',
	JPEG_TO_PNG: 'jpeg to png converter',
	JPEG_TO_PNG_LANDING: 'jpeg to png converter landing',
	JPG_TO_PNG: 'jpg to png converter',
	JPG_TO_PNG_LANDING: 'jpg to png converter landing',
	IMAGE_CONVERTER: 'image converter',
	IMAGE_CONVERTER_LANDING: 'image converter landing',
	VIDEO_CONVERTER: 'video converter',
	VIDEO_CONVERTER_LANDING: 'video converter landing',
	VIDEO_COMPRESSOR: 'video compressor',
	VIDEO_COMPRESSOR_LANDING: 'video compressor landing',
	VIDEO_BACKGROUND_REMOVER: 'video background remover',
	VIDEO_BACKGROUND_REMOVER_LANDING: 'video background remover landing',
	VIDEO_ENHANCER: 'video enhancer',
	VIDEO_ENHANCER_LANDING: 'video enhancer landing',
	AI_VOICE_GENERATOR: 'ai voice generator',
	AI_VOICE_GENERATOR_LANDING: 'ai voice generator landing',
	TEXT_TO_SPEECH: 'text to speech',
	TEXT_TO_SPEECH_LANDING: 'text to speech landing',
	AI_MUSIC_GENERATOR: 'ai music generator',
	AI_MUSIC_GENERATOR_LANDING: 'ai music generator landing',
	AI_SONG_GENERATOR: 'ai song generator',
	AI_SONG_GENERATOR_LANDING: 'ai song generator landing',
	AI_TRANSCRIPTION: 'ai transcription',
	AI_TRANSCRIPTION_LANDING: 'ai transcription landing',
	AUDIO_TO_TEXT: 'audio to text',
	AUDIO_TO_TEXT_LANDING: 'audio to text landing',
	VIDEO_TO_TEXT: 'video to text',
	VIDEO_TO_TEXT_LANDING: 'video to text landing',
	SPEECH_TO_TEXT: 'speech to text',
	SPEECH_TO_TEXT_LANDING: 'speech to text landing',
	AI_SUMMARIZER: 'ai summarizer',
	AI_SUMMARIZER_LANDING: 'ai summarizer landing',
	VIDEO_SIZE_REDUCER: 'video size reducer',
	VIDEO_SIZE_REDUCER_LANDING: 'video size reducer landing',
	MP4_TO_MP3_CONVERTER: 'mp4 to mp3 converter',
	MP4_TO_MP3_CONVERTER_LANDING: 'mp4 to mp3 converter landing',
	MP3_CONVERTER: 'mp3 converter',
	MP3_CONVERTER_LANDING: 'mp3 converter landing',
	GIF_MAKER: 'gif maker',
	GIF_MAKER_LANDING: 'gif maker landing',
	VIDEO_TO_MP3_CONVERTER: 'video to mp3 converter',
	VIDEO_TO_MP3_CONVERTER_LANDING: 'video to mp3 converter landing',
	MOV_TO_MP4_CONVERTER: 'mov to mp4 converter',
	MOV_TO_MP4_CONVERTER_LANDING: 'mov to mp4 converter landing',
	VIDEO_TO_GIF_CONVERTER: 'video to gif converter',
	VIDEO_TO_GIF_CONVERTER_LANDING: 'video to gif converter landing',
	MKV_TO_MP4_CONVERTER: 'mkv to mp4 converter',
	MKV_TO_MP4_CONVERTER_LANDING: 'mkv to mp4 converter landing',
	MP4_TO_GIF_CONVERTER: 'mp4 to gif converter',
	MP4_TO_GIF_CONVERTER_LANDING: 'mp4 to gif converter landing',
	VIDEO_TO_AUDIO_CONVERTER: 'video to audio converter',
	VIDEO_TO_AUDIO_CONVERTER_LANDING: 'video to audio converter landing',
	AVI_TO_MP4_CONVERTER: 'avi to mp4 converter',
	AVI_TO_MP4_CONVERTER_LANDING: 'avi to mp4 converter landing',
	WEBM_TO_MP4_CONVERTER: 'webm to mp4 converter',
	WEBM_TO_MP4_CONVERTER_LANDING: 'webm to mp4 converter landing',
	GIF_TO_MP4_CONVERTER: 'gif to mp4 converter',
	GIF_TO_MP4_CONVERTER_LANDING: 'gif to mp4 converter landing',
	MPEG_TO_MP3_CONVERTER: 'mpeg to mp3 converter',
	MPEG_TO_MP3_CONVERTER_LANDING: 'mpeg to mp3 converter landing',
	GIF_TO_VIDEO_CONVERTER: 'gif to video converter',
	GIF_TO_VIDEO_CONVERTER_LANDING: 'gif to video converter landing',
	MOV_TO_MP3_CONVERTER: 'mov to mp3 converter',
	MOV_TO_MP3_CONVERTER_LANDING: 'mov to mp3 converter landing',
	MP4_TO_WAV_CONVERTER: 'mp4 to wav converter',
	MP4_TO_WAV_CONVERTER_LANDING: 'mp4 to wav converter landing',
	MOV_TO_GIF_CONVERTER: 'mov to gif converter',
	MOV_TO_GIF_CONVERTER_LANDING: 'mov to gif converter landing',
	IMAGE_COMPRESSOR: 'image compressor',
	IMAGE_COMPRESSOR_LANDING: 'image compressor landing',
	LOWER_IMAGE_SIZE: 'lower image size',
	LOWER_IMAGE_SIZE_LANDING: 'lower image size landing',
	REDUCE_IMAGE_SIZE: 'reduce image size',
	REDUCE_IMAGE_SIZE_LANDING: 'reduce image size landing',
	DECREASE_PICTURE_SIZE: 'decrease picture size',
	DECREASE_PICTURE_SIZE_LANDING: 'decrease picture size landing',
	MINIMIZE_PICTURE_SIZE: 'minimize picture size',
	MINIMIZE_PICTURE_SIZE_LANDING: 'minimize picture size landing',
	CONDENSE_IMAGE: 'condense image',
	CONDENSE_IMAGE_LANDING: 'condense image landing',
	COMPRESS_JPG: 'compress jpg',
	COMPRESS_JPG_LANDING: 'compress jpg landing',
	COMPRESS_JPEG: 'compress jpeg',
	COMPRESS_JPEG_LANDING: 'compress jpeg landing',
	RESIZE_PHOTO_KB: 'resize photo kb',
	RESIZE_PHOTO_KB_LANDING: 'resize photo kb landing',
	SHRINK_IMAGE_ONLINE: 'shrink image online',
	SHRINK_IMAGE_ONLINE_LANDING: 'shrink image online landing',
	COMPRESS_PNG: 'compress png',
	COMPRESS_PNG_LANDING: 'compress png landing',
	COMPACT_IMAGES: 'compact images',
	COMPACT_IMAGES_LANDING: 'compact images landing',
	PHOTO_TRANSLATOR: 'photo translator',
	PHOTO_TRANSLATOR_LANDING: 'photo translator landing',
	ENGLISH_IMAGE_TRANSLATOR: 'english image translator',
	ENGLISH_IMAGE_TRANSLATOR_LANDING: 'english image translator landing',
	TRANSLATE_IMAGE_TO_ENGLISH: 'translate image to english',
	TRANSLATE_IMAGE_TO_ENGLISH_LANDING: 'translate image to english landing',
	AI_BABY_GENERATOR: 'ai baby generator',
	AI_BABY_GENERATOR_LANDING: 'ai baby generator landing',
	BABY_FACE_GENERATOR: 'baby face generator',
	BABY_FACE_GENERATOR_LANDING: 'baby face generator landing',
	BLUR_IMAGE: 'blur image',
	BLUR_IMAGE_LANDING: 'blur image landing',
	BLUR_EFFECT: 'blur effect',
	BLUR_EFFECT_LANDING: 'blur effect landing',
	BLUR_FACE_IN_PHOTO: 'blur face in photo',
	BLUR_FACE_IN_PHOTO_LANDING: 'blur face in photo landing',
	BLUR_TEXT_IN_IMAGE: 'blur text in image',
	BLUR_TEXT_IN_IMAGE_LANDING: 'blur text in image landing',
	PIXELATE_IMAGE: 'pixelate image',
	PIXELATE_IMAGE_LANDING: 'pixelate image landing',
	AI_AGE_PROGRESSION: 'ai age progression',
	AI_AGE_PROGRESSION_V2: 'ai age progression v2',
	AI_AGE_PROGRESSION_LANDING: 'ai age progression landing',
	AI_AGE_PROGRESSION_LANDING_V2: 'ai age progression landing v2',
	AI_AGE_FILTER: 'ai age filter',
	AI_AGE_FILTER_LANDING: 'ai age filter landing',
	WHAT_WILL_I_LOOK_LIKE_WHEN_IM_OLDER: 'what will i look like when im older',
	WHAT_WILL_I_LOOK_LIKE_WHEN_IM_OLDER_LANDING:
		'what will i look like when im older landing',
	IMAGE_SPLITTER: 'image splitter',
	IMAGE_SPLITTER_LANDING: 'image splitter landing',
	GRID_MAKER: 'grid maker',
	GRID_MAKER_LANDING: 'grid maker landing',
	AI_PROFESSIONAL_HEADSHOT_GENERATOR: 'ai professional headshot generator',
	AI_PROFESSIONAL_HEADSHOT_GENERATOR_LANDING:
		'ai professional headshot generator landing',
	AI_SPICY_HEADSHOT_GENERATOR: 'ai spicy headshot generator',
	AI_SPICY_HEADSHOT_GENERATOR_LANDING: 'ai spicy headshot generator landing',
	AI_PREGNANCY_HEADSHOT_GENERATOR: 'ai pregnancy headshot generator',
	AI_PREGNANCY_HEADSHOT_GENERATOR_LANDING:
		'ai pregnancy headshot generator landing',
	FACE_SHAPE_DETECTOR: 'face shape detector',
	FACE_SHAPE_DETECTOR_LANDING: 'face shape detector landing',
	QR_CODE_GENERATOR: 'qr code generator',
	QR_CODE_GENERATOR_LANDING: 'qr code generator landing',
	BARCODE_GENERATOR: 'barcode generator',
	BARCODE_GENERATOR_LANDING: 'barcode generator landing',
	IDEOGRAM_AI_IMAGE_GENERATOR: 'ideogram ai image generator',
	IDEOGRAM_AI_IMAGE_GENERATOR_LANDING: 'ideogram ai image generator landing',
	QWEN_IMAGE_AI_GENERATOR: 'qwen image ai generator',
	QWEN_IMAGE_AI_GENERATOR_LANDING: 'qwen image ai generator landing',
	VEO_AI_VIDEO_GENERATOR: 'veo ai video generator',
	VEO_AI_VIDEO_GENERATOR_LANDING: 'veo ai video generator landing',
	GEMINI_OMNI_AI_VIDEO_GENERATOR: 'gemini omni ai video generator',
	GEMINI_OMNI_AI_VIDEO_GENERATOR_LANDING:
		'gemini omni ai video generator landing',
	WAN_3_0_AI_VIDEO_GENERATOR: 'wan 3.0 ai video generator',
	WAN_3_0_AI_VIDEO_GENERATOR_LANDING: 'wan 3.0 ai video generator landing',
	FLUX_3_VIDEO_AI_GENERATOR: 'flux 3 video ai generator',
	FLUX_3_VIDEO_AI_GENERATOR_LANDING: 'flux 3 video ai generator landing',
	HAPPY_HORSE_AI_VIDEO_GENERATOR: 'happy horse ai video generator',
	HAPPY_HORSE_AI_VIDEO_GENERATOR_LANDING:
		'happy horse ai video generator landing',
	HAILUO_AI_VIDEO_GENERATOR: 'hailuo ai video generator',
	HAILUO_AI_VIDEO_GENERATOR_LANDING: 'hailuo ai video generator landing',
	SEEDANCE_AI_VIDEO_GENERATOR: 'seedance ai video generator',
	SEEDANCE_AI_VIDEO_GENERATOR_LANDING: 'seedance ai video generator landing',
	SEEDANCE_2_5_AI_VIDEO_GENERATOR: 'seedance 2.5 ai video generator',
	SEEDANCE_2_5_AI_VIDEO_GENERATOR_LANDING:
		'seedance 2.5 ai video generator landing',
	KLING_AI_VIDEO_GENERATOR: 'kling ai video generator',
	KLING_AI_VIDEO_GENERATOR_LANDING: 'kling ai video generator landing',
	GROK_AI_VIDEO_GENERATOR: 'grok ai video generator',
	GROK_AI_VIDEO_GENERATOR_LANDING: 'grok ai video generator landing',
	PIXVERSE_AI_VIDEO_GENERATOR: 'pixverse ai video generator',
	PIXVERSE_AI_VIDEO_GENERATOR_LANDING: 'pixverse ai video generator landing',
	NANO_BANANA_AI_IMAGE_GENERATOR: 'nano banana ai image generator',
	NANO_BANANA_AI_IMAGE_GENERATOR_LANDING:
		'nano banana ai image generator landing',
	GROK_IMAGINE_AI_IMAGE_GENERATOR: 'grok imagine ai image generator',
	GROK_IMAGINE_AI_IMAGE_GENERATOR_LANDING:
		'grok imagine ai image generator landing',
	RECRAFT_AI_IMAGE_GENERATOR: 'recraft ai image generator',
	RECRAFT_AI_IMAGE_GENERATOR_LANDING: 'recraft ai image generator landing',
	FLUX_2_AI_IMAGE_GENERATOR: 'flux 2 ai image generator',
	FLUX_2_AI_IMAGE_GENERATOR_LANDING: 'flux 2 ai image generator landing',
	GPT_IMAGE_AI_GENERATOR: 'gpt image ai generator',
	GPT_IMAGE_AI_GENERATOR_LANDING: 'gpt image ai generator landing',
	MAI_IMAGE_AI_GENERATOR: 'mai image ai generator',
	MAI_IMAGE_AI_GENERATOR_LANDING: 'mai image ai generator landing',
	META_MUSE_IMAGE_AI_GENERATOR: 'meta muse image ai generator',
	META_MUSE_IMAGE_AI_GENERATOR_LANDING: 'meta muse image ai generator landing',
	SEEDREAM_AI_IMAGE_GENERATOR: 'seedream ai image generator',
	SEEDREAM_AI_IMAGE_GENERATOR_LANDING: 'seedream ai image generator landing',
	IMAGE_TO_IMAGE_AI: 'image to image ai',
	IMAGE_TO_IMAGE_AI_LANDING: 'image to image ai landing',
};

export const MONETIZATION_TEST = {
	NON_TIER_1: 'non_tier_1',
} as const;

export const LANDING_CONSTANTS = {
	MAX_FILE_SIZE: 20 * 1024 * 1024, // 20MB
	MAX_VIDEO_FILE_SIZE: 2 * 1024 * 1024 * 1024, // 2GB
	MAX_SPEECH_TO_TEXT_DURATION: 3 * 60 * 60, // 3 hours, in seconds
	MAX_FILES: 1,
	ACCEPTED_IMAGE_TYPES_DROPZONE: {
		'image/jpg': ['.jpeg', '.jpg'],
		'image/png': ['.png'],
		'image/webp': ['.webp'],
	},
	ACCEPTED_IMAGE_TYPES_DROPZONE_CONVERTER_COMPRESSOR: {
		'image/jpg': ['.jpeg', '.jpg'],
		'image/png': ['.png'],
		'image/webp': ['.webp'],
		'image/heic': ['.heic'],
		'image/heif': ['.heif'],
		'image/tiff': ['.tiff'],
		'image/bmp': ['.bmp'],
	},
	ACCEPTED_VIDEO_TYPES_DROPZONE: {
		'video/x-msvideo': ['.avi'],
		'video/x-flv': ['.flv'],
		'image/gif': ['.gif'],
		'video/hevc': ['.hevc'],
		'video/x-m4v': ['.m4v'],
		'video/x-matroska': ['.mkv'],
		'video/quicktime': ['.mov'],
		'video/mp4': ['.mp4'],
		'video/mpeg': ['.mpeg', '.mpg'],
		'application/x-shockwave-flash': ['.swf'],
		'video/mp2t': ['.ts'],
		'video/dvd': ['.vob'],
		'video/webm': ['.webm'],
		'video/x-ms-wmv': ['.wmv'],
	},
	ACCEPTED_AUDIO_TYPES_DROPZONE: {
		'audio/mpeg': ['.mp3'],
		'audio/wav': ['.wav'],
		'audio/x-m4a': ['.m4a'],
		'audio/aac': ['.aac'],
		'audio/ogg': ['.ogg'],
		'audio/flac': ['.flac'],
		'audio/webm': ['.weba'],
	},
	PAGE_IMAGE_ENHANCER: 'image-enhancer',
	PAGE_IMAGE_UPSCALER: 'image-upscaler',
	PAGE_IMAGE_UPSCALE_V3: 'image-upscale-v3',
	PAGE_OBJECT_REMOVER: 'object-remover',
	PAGE_BACKGROUND_REMOVER: 'background-remover',
	PAGE_TOOLS: 'tools',
	PAGE_AI_IMAGE_GENERATOR: 'ai-image-generator',
	PAGE_TEXT_TO_IMAGE_AI: 'text-to-image-ai',
	PAGE_TEXT_TO_ART_AI: 'text-to-art-ai',
	PAGE_HEADSHOT_GENERATOR: 'headshot-generator',
	PAGE_HEADSHOT_GENERATOR_V2: 'headshot-generator-v2',
	PAGE_WATERMARK_REMOVER: 'watermark-remover',
	PAGE_VIDEO_WATERMARK_REMOVER: 'video-watermark-remover',
	PAGE_IMAGE_WATERMARK_REMOVER: 'image-watermark-remover',
	PAGE_QR_CODE_GENERATOR: 'qr-code-generator',
	PAGE_BARCODE_GENERATOR: 'barcode-generator',
	PAGE_AI_IMAGE_COMBINER: 'ai-image-combiner',
	PAGE_PHOTO_TRANSLATOR: 'photo-translator',
	PAGE_ENGLISH_IMAGE_TRANSLATOR: 'english-image-translator',
	PAGE_TRANSLATE_IMAGE_TO_ENGLISH: 'translate-image-to-english',
	PAGE_IMAGE_RESIZER: 'image-resizer',
	PAGE_CROP_IMAGE: 'crop-image',
	PAGE_COLOR_PALETTE_FROM_IMAGE: 'color-palette-from-image',
	PAGE_HEX_COLOR_PICKER_FROM_IMAGE: 'hex-color-picker-from-image',
	PAGE_COLOR_PICKER_FROM_IMAGE: 'color-picker-from-image',
	PAGE_RGB_COLOR_PICKER_FROM_IMAGE: 'rgb-color-picker-from-image',
	PAGE_FLIP_IMAGE: 'flip-image',
	PAGE_ROTATE_IMAGE: 'rotate-image',
	PAGE_BACKGROUND_EDITOR: 'background-editor',
	PAGE_BACKGROUND_CHANGER: 'background-changer',
	PAGE_BLUR_BACKGROUND: 'blur-background',
	PAGE_PASSPORT_PHOTO_MAKER: 'passport-photo-maker',
	PAGE_AI_CLAY_FILTER: 'ai-clay-filter',
	PAGE_AI_FILTERS: 'ai-filters',
	PAGE_ANIME_GENERATOR: 'anime-generator',
	PAGE_CARTOON_GENERATOR: 'cartoon-generator',
	PAGE_AI_POKEMON_GENERATOR: 'ai-pokemon-generator',
	PAGE_PIXAR_AI_GENERATOR: 'pixar-ai-generator',
	PAGE_AI_CHIBI_MAKER: 'ai-chibi-maker',
	PAGE_AI_IMAGE_EXTENDER: 'image-extender',
	PAGE_AI_IMAGE_EXTENDER_V2: 'image-extender-v2',
	PAGE_AI_IMAGE_EDITOR: 'ai-image-editor',
	PAGE_HAIRSTYLE_CHANGER: 'hairstyle-changer',
	PAGE_HAIRSTYLE_CHANGER_V2: 'hairstyle-changer-v2',
	PAGE_AI_IMAGE_QUALITY_IMPROVER: 'increase-image-quality',
	PAGE_AI_IMAGE_DEPIXELIZER: 'unpixelate-image',
	PAGE_PHOTO_CONVERTER: 'hd-photo-converter',
	PAGE_AI_RELIGHT: 'ai-relight',
	PAGE_AI_RETAKE: 'ai-retake',
	PAGE_AI_IMAGE_DENOISER: 'image-denoiser',
	PAGE_RESOLUTION_INCREASER: 'resolution-increaser',
	PAGE_AI_IMAGE_ENLARGER: 'image-enlarger',
	PAGE_AI_PHOTO_RESTORATION: 'photo-restoration',
	PAGE_CLOTHES_CHANGER: 'clothes-changer',
	PAGE_UNBLUR_IMAGE: 'unblur-image',
	PAGE_BLUR_IMAGE: 'blur-image',
	PAGE_BLUR_EFFECT: 'blur-effect',
	PAGE_BLUR_FACE_IN_PHOTO: 'blur-face-in-photo',
	PAGE_BLUR_TEXT_IN_IMAGE: 'blur-text-in-image',
	PAGE_PIXELATE_IMAGE: 'pixelate-image',
	PAGE_IMAGE_SHARPENER: 'image-sharpener',
	PAGE_AI_IMAGE_DETECTOR: 'ai-image-detector',
	PAGE_PHOTO_COLORIZER: 'photo-colorizer',
	PAGE_PHOTO_COLORIZER_V2: 'photo-colorizer-v2',
	PAGE_IMAGE_TO_TEXT: 'image-to-text',
	PAGE_SOUTH_PARK_CHARACTER_GENERATOR: 'south-park-character-generator',
	PAGE_AI_ART_GENERATOR: 'ai-art-generator',
	PAGE_AI_NEON_FILTER: 'ai-neon-filter',
	PAGE_AI_BRATZ_GENERATOR: 'ai-bratz-generator',
	PAGE_AI_DISNEY_FILTER: 'ai-disney-filter',
	PAGE_PHOTO_RECOLOR: 'photo-recolor',
	PAGE_AI_FACE_SWAP: 'ai-face-swap',
	PAGE_MAIN: 'main',
	PAGE_PHOTO_TO_ILLUSTRATION: 'photo-to-illustration',
	PAGE_IMAGE_TO_DRAWING: 'image-to-drawing',
	PAGE_AI_COMIC_FILTER: 'ai-comic-filter',
	PAGE_PHOTO_TO_PAINTING: 'photo-to-painting',
	PAGE_PHOTO_TO_SKETCH: 'photo-to-sketch',
	PAGE_AI_BARBIE_DOLL: 'ai-barbie-doll',
	PAGE_AI_DOLL_GENERATOR: 'ai-doll-generator',
	PAGE_AI_MANGA_GENERATOR: 'ai-manga-generator',
	PAGE_AI_ACTION_FIGURE_GENERATOR: 'ai-action-figure-generator',
	PAGE_AI_TOY_GENERATOR: 'ai-toy-generator',
	PAGE_SUCCESS: 'success',
	PAGE_GENERATIVE_FILL: 'generative-fill',
	PAGE_AI_BACKGROUND: 'ai-background',
	PAGE_AI_PFP_MAKER: 'ai-pfp-maker',
	PAGE_AI_PROFILE_PICTURE_MAKER: 'ai-profile-picture-maker',
	PAGE_AI_AVATAR_GENERATOR: 'ai-avatar-generator',
	PAGE_AI_PORTRAIT_GENERATOR: 'ai-portrait-generator',
	PAGE_PROFESSIONAL_AI_HEADSHOTS: 'professional-ai-headshots',
	PAGE_AI_CV_PHOTO_GENERATOR: 'ai-cv-photo-generator',
	PAGE_AI_BUSINESS_PHOTO_GENERATOR: 'ai-business-photo-generator',
	PAGE_AI_DATING_PHOTO_GENERATOR: 'ai-dating-photo-generator',
	PAGE_AI_TATTOO_GENERATOR: 'ai-tattoo-generator',
	PAGE_TATTOO_FONT_GENERATOR: 'tattoo-font-generator',
	PAGE_FONT_GENERATOR: 'font-generator',
	PAGE_TATTOO_TEXT_GENERATOR: 'tattoo-text-generator',
	PAGE_TATTOO_FROM_PHOTO_CONVERTER: 'tattoo-from-photo-converter',
	PAGE_CUTOUT_IMAGE: 'cutout-image',
	PAGE_PNG_MAKER: 'png-maker',
	PAGE_TRANSPARENT_BACKGROUND: 'transparent-background',
	PAGE_SIGNATURE_BACKGROUND_REMOVER: 'signature-background-remover',
	PAGE_DELETE_BACKGROUND: 'delete-background',
	PAGE_CLEAR_BACKGROUND: 'clear-background',
	PAGE_WHITE_BACKGROUND: 'white-background',
	PAGE_BLACK_BACKGROUND: 'black-background',
	PAGE_BACKGROUND_COLOR_CHANGER: 'background-color-changer',
	PAGE_AI_LOGO_GENERATOR: 'ai-logo-generator',
	PAGE_IMAGE_COMPRESSOR: 'image-compressor',
	PAGE_COMPRESS_JPG: 'compress-jpg',
	PAGE_COMPRESS_JPEG: 'compress-jpeg',
	PAGE_RESIZE_PHOTO_KB: 'resize-photo-kb',
	PAGE_SHRINK_IMAGE_ONLINE: 'shrink-image-online',
	PAGE_COMPRESS_PNG: 'compress-png',
	PAGE_COMPACT_IMAGES: 'compact-images',
	PAGE_LOWER_IMAGE_SIZE: 'lower-image-size',
	PAGE_REDUCE_IMAGE_SIZE: 'reduce-image-size',
	PAGE_DECREASE_PICTURE_SIZE: 'decrease-picture-size',
	PAGE_MINIMIZE_PICTURE_SIZE: 'minimize-picture-size',
	PAGE_CONDENSE_IMAGE: 'condense-image',
	PAGE_WEBP_TO_PNG_CONVERTER: 'webp-to-png-converter',
	PAGE_WEBP_TO_JPG_CONVERTER: 'webp-to-jpg-converter',
	PAGE_WEBP_TO_JPEG_CONVERTER: 'webp-to-jpeg-converter',
	PAGE_HEIC_TO_JPEG_CONVERTER: 'heic-to-jpeg-converter',
	PAGE_HEIC_TO_JPG_CONVERTER: 'heic-to-jpg-converter',
	PAGE_HEIC_TO_PNG_CONVERTER: 'heic-to-png-converter',
	PAGE_IMAGE_TO_JPEG_CONVERTER: 'image-to-jpeg-converter',
	PAGE_IMAGE_TO_HEIC_CONVERTER: 'image-to-heic-converter',
	PAGE_IMAGE_TO_JPG_CONVERTER: 'image-to-jpg-converter',
	PAGE_IMAGE_TO_BMP_CONVERTER: 'image-to-bmp-converter',
	PAGE_IMAGE_TO_TIFF_CONVERTER: 'image-to-tiff-converter',
	PAGE_IMAGE_CONVERTER: 'image-converter',
	PAGE_VIDEO_CONVERTER: 'video-converter',
	PAGE_VIDEO_COMPRESSOR: 'video-compressor',
	PAGE_VIDEO_BACKGROUND_REMOVER: 'video-background-remover',
	PAGE_VIDEO_ENHANCER: 'video-enhancer',
	PAGE_AI_VOICE_GENERATOR: 'ai-voice-generator',
	PAGE_TEXT_TO_SPEECH: 'text-to-speech',
	PAGE_AI_MUSIC_GENERATOR: 'ai-music-generator',
	PAGE_AI_SONG_GENERATOR: 'ai-song-generator',
	PAGE_AI_TRANSCRIPTION: 'ai-transcription',
	PAGE_AUDIO_TO_TEXT: 'audio-to-text',
	PAGE_VIDEO_TO_TEXT: 'video-to-text',
	PAGE_SPEECH_TO_TEXT: 'speech-to-text',
	PAGE_AI_SUMMARIZER: 'ai-summarizer',
	PAGE_VIDEO_SIZE_REDUCER: 'video-size-reducer',
	PAGE_MP4_TO_MP3_CONVERTER: 'mp4-to-mp3-converter',
	PAGE_MP3_CONVERTER: 'mp3-converter',
	PAGE_GIF_MAKER: 'gif-maker',
	PAGE_VIDEO_TO_MP3_CONVERTER: 'video-to-mp3-converter',
	PAGE_MOV_TO_MP4_CONVERTER: 'mov-to-mp4-converter',
	PAGE_VIDEO_TO_GIF_CONVERTER: 'video-to-gif-converter',
	PAGE_MKV_TO_MP4_CONVERTER: 'mkv-to-mp4-converter',
	PAGE_MP4_TO_GIF_CONVERTER: 'mp4-to-gif-converter',
	PAGE_VIDEO_TO_AUDIO_CONVERTER: 'video-to-audio-converter',
	PAGE_AVI_TO_MP4_CONVERTER: 'avi-to-mp4-converter',
	PAGE_WEBM_TO_MP4_CONVERTER: 'webm-to-mp4-converter',
	PAGE_GIF_TO_MP4_CONVERTER: 'gif-to-mp4-converter',
	PAGE_MPEG_TO_MP3_CONVERTER: 'mpeg-to-mp3-converter',
	PAGE_GIF_TO_VIDEO_CONVERTER: 'gif-to-video-converter',
	PAGE_MOV_TO_MP3_CONVERTER: 'mov-to-mp3-converter',
	PAGE_MP4_TO_WAV_CONVERTER: 'mp4-to-wav-converter',
	PAGE_MOV_TO_GIF_CONVERTER: 'mov-to-gif-converter',
	PAGE_PNG_CONVERTER: 'png-converter',
	PAGE_WEBP_CONVERTER: 'webp-converter',
	PAGE_PNG_TO_JPEG_CONVERTER: 'png-to-jpeg-converter',
	PAGE_PNG_TO_BMP_CONVERTER: 'png-to-bmp-converter',
	PAGE_PNG_TO_JPG_CONVERTER: 'png-to-jpg-converter',
	PAGE_PNG_TO_WEBP_CONVERTER: 'png-to-webp-converter',
	PAGE_JPG_TO_WEBP_CONVERTER: 'jpg-to-webp-converter',
	PAGE_JPEG_TO_WEBP_CONVERTER: 'jpeg-to-webp-converter',
	PAGE_JPEG_TO_JPG_CONVERTER: 'jpeg-to-jpg-converter',
	PAGE_JPG_TO_JPEG_CONVERTER: 'jpg-to-jpeg-converter',
	PAGE_JPG_TO_BMP_CONVERTER: 'jpg-to-bmp-converter',
	PAGE_JPG_TO_TIFF_CONVERTER: 'jpg-to-tiff-converter',
	PAGE_JPEG_TO_TIFF_CONVERTER: 'jpeg-to-tiff-converter',
	PAGE_JPEG_TO_BMP_CONVERTER: 'jpeg-to-bmp-converter',
	PAGE_JPEG_TO_PNG_CONVERTER: 'jpeg-to-png-converter',
	PAGE_JPG_TO_PNG_CONVERTER: 'jpg-to-png-converter',
	PAGE_TIFF_TO_JPG_CONVERTER: 'tiff-to-jpg-converter',
	PAGE_TIFF_TO_JPEG_CONVERTER: 'tiff-to-jpeg-converter',
	PAGE_TIFF_TO_PNG_CONVERTER: 'tiff-to-png-converter',
	PAGE_BMP_TO_JPEG_CONVERTER: 'bmp-to-jpeg-converter',
	PAGE_BMP_TO_PNG_CONVERTER: 'bmp-to-png-converter',
	PAGE_BMP_TO_JPG_CONVERTER: 'bmp-to-jpg-converter',
	PAGE_AI_BABY_GENERATOR: 'ai-baby-generator',
	PAGE_BABY_FACE_GENERATOR: 'baby-face-generator',
	PAGE_AI_AGE_PROGRESSION: 'ai-age-progression',
	PAGE_AI_AGE_PROGRESSION_V2: 'ai-age-progression-v2',
	PAGE_AI_AGE_FILTER: 'ai-age-filter',
	PAGE_WHAT_WILL_I_LOOK_LIKE_WHEN_IM_OLDER:
		'what-will-i-look-like-when-im-older',
	PAGE_IMAGE_SPLITTER: 'image-splitter',
	PAGE_GRID_MAKER: 'grid-maker',
	PAGE_AI_PROFESSIONAL_HEADSHOT_GENERATOR: 'ai-professional-headshot-generator',
	PAGE_AI_SPICY_HEADSHOT_GENERATOR: 'ai-spicy-headshot-generator',
	PAGE_AI_PREGNANCY_HEADSHOT_GENERATOR: 'ai-pregnancy-headshot-generator',
	PAGE_FACE_SHAPE_DETECTOR: 'face-shape-detector',
	PAGE_TEXT_TO_VIDEO: 'text-to-video',
	PAGE_IMAGE_TO_VIDEO: 'image-to-video',
	PAGE_AI_VIDEO_GENERATOR: 'ai-video-generator',
	PAGE_VEO_AI_VIDEO_GENERATOR: 'veo-ai-video-generator',
	PAGE_GEMINI_OMNI_AI_VIDEO_GENERATOR: 'gemini-omni-ai-video-generator',
	PAGE_WAN_3_0_AI_VIDEO_GENERATOR: 'wan-3-0-ai-video-generator',
	PAGE_FLUX_3_VIDEO_AI_GENERATOR: 'flux-3-video-ai-generator',
	PAGE_HAPPY_HORSE_AI_VIDEO_GENERATOR: 'happy-horse-ai-video-generator',
	PAGE_HAILUO_AI_VIDEO_GENERATOR: 'hailuo-ai-video-generator',
	PAGE_SEEDANCE_AI_VIDEO_GENERATOR: 'seedance-ai-video-generator',
	PAGE_SEEDANCE_2_5_AI_VIDEO_GENERATOR: 'seedance-2-5-ai-video-generator',
	PAGE_KLING_AI_VIDEO_GENERATOR: 'kling-ai-video-generator',
	PAGE_GROK_AI_VIDEO_GENERATOR: 'grok-ai-video-generator',
	PAGE_PIXVERSE_AI_VIDEO_GENERATOR: 'pixverse-ai-video-generator',
	PAGE_IDEOGRAM_AI_IMAGE_GENERATOR: 'ideogram-ai-image-generator',
	PAGE_QWEN_IMAGE_AI_GENERATOR: 'qwen-image-ai-generator',
	PAGE_NANO_BANANA_AI_IMAGE_GENERATOR: 'nano-banana-ai-image-generator',
	PAGE_GROK_IMAGINE_AI_IMAGE_GENERATOR: 'grok-imagine-ai-image-generator',
	PAGE_RECRAFT_AI_IMAGE_GENERATOR: 'recraft-ai-image-generator',
	PAGE_FLUX_2_AI_IMAGE_GENERATOR: 'flux-2-ai-image-generator',
	PAGE_GPT_IMAGE_AI_GENERATOR: 'gpt-image-ai-generator',
	PAGE_MAI_IMAGE_AI_GENERATOR: 'mai-image-ai-generator',
	PAGE_META_MUSE_IMAGE_AI_GENERATOR: 'meta-muse-image-ai-generator',
	PAGE_SEEDREAM_AI_IMAGE_GENERATOR: 'seedream-ai-image-generator',
	PAGE_IMAGE_TO_IMAGE_AI: 'image-to-image-ai',
};

export const LANDING_COOKIE_STORAGE = {
	IMAGE_FROM_LANDING: 'funnel_image_from_landing',
	// Plan (product name) picked on /pricing. Read by the web app's standalone
	// checkout — same domain in production, so the cookie travels with the user
	PLAN_FROM_LANDING: 'plan_from_landing',
	LINK_FROM_LANDING: 'funnel_link_from_landing',
	VIDEO_FROM_LANDING: 'funnel_video_from_landing',
	// Watermark Remover takes both photo and video, so it hands the funnel a single
	// key of its own — no guessing which of the two media cookies is the current one
	WATERMARK_MEDIA_FROM_LANDING: 'funnel_watermark_media',
	// Speech to Text funnel reads one JSON cookie: { source: 'file' | 'youtube', url }
	SPEECH_TO_TEXT_FROM_LANDING: 'funnel_speech_to_text_from_landing',
	AUTH_TOKEN: 'auth_token',
	REFRESH_TOKEN: 'refresh_token',
};

export const LANDING_LOCAL_STORAGE = {
	LOGIN_METHOD: 'login_method',
	LOGIN_TYPE: 'login_type',
	LOGIN_STATE: 'login_state',
	USER: 'user',
} as const;

export const LANDING_LOGIN_METHOD = {
	ANONYMOUS: 'anonymous',
	EMAIL: 'email',
} as const;

export const LANDING_LOGIN_TYPE = 'funnel';
